export const version = 'kunde-v1.20.0-SNAPSHOT-edb955751baa51b65dc71b986493138bc2139042';